
import { DenseStrategy } from './DenseStrategy';
import { SparseStrategy } from './SparseStrategy';
export class DenseSparseChooseBasedOnThreshold {
    constructor(threshold) {
        this.threshold = threshold;
    }
    call(fill) {
        if (fill > this.threshold) {
            return DenseStrategy;
        }
        else {
            return SparseStrategy;
        }
    }
}
export class AlwaysSparse {
    call() {
        return SparseStrategy;
    }
}
export class AlwaysDense {
    call() {
        return DenseStrategy;
    }
}
